(function (window, $) {
  var Cls = {};
  var _DELAY = 0;
  var temp = -35;
  var firstFlag = false;
  var $catBox = null;
  var $hide = null;
  var $title = null;
  var $thermometer = null;
  var $cat0_obj1 = null;
  var $cat0_obj2 = null;
  var $cat0_obj3 = null;
  var $cat0_obj4 = null;
  var $cat1_obj1 = null;
  var $cat1_obj2 = null;
  var $cat1_obj3 = null;
  var $cat1_obj4 = null;
  var $cat2_obj1 = null;
  var $cat2_obj2 = null;
  var $cat2_obj3 = null;
  var $cat2_obj4 = null;
  var $cat3_obj1 = null;
  var $cat3_obj2 = null;
  var $cat3_obj3 = null;
  var $cat3_obj4 = null;
  var $cat4_obj1 = null;
  var $cat4_obj2 = null;
  var $cat4_obj3 = null;
  var $cat4_obj4 = null;

  var $cat0_text = null;
  var $cat1_text = null;
  var $cat2_text = null;
  var $cat3_text = null;
  var $cat4_text = null;

  var $cat0 = null;
  var $cat1 = null;
  var $cat2 = null;
  var $cat3 = null;
  var $cat4 = null;

  Cls.isAnimated = false;

  Cls.init = function () {
    _DELAY = 600;
    $catBox = $("#seg1 .catBox");
    $hide = $("#seg1 .hide");
    $title = $("#seg1 .title1");
    $thermometer = $("#seg1 .thermometer");
    $cat0_obj1 = $("#seg1 .cat0 .obj1");
    $cat0_obj2 = $("#seg1 .cat0 .obj2");
    $cat0_obj3 = $("#seg1 .cat0 .obj3");
    $cat0_obj4 = $("#seg1 .cat0 .obj4");
    $cat1_obj1 = $("#seg1 .cat1 .obj1");
    $cat1_obj2 = $("#seg1 .cat1 .obj2");
    $cat1_obj3 = $("#seg1 .cat1 .obj3");
    $cat1_obj4 = $("#seg1 .cat1 .obj4");
    $cat2_obj1 = $("#seg1 .cat2 .obj1");
    $cat2_obj2 = $("#seg1 .cat2 .obj2");
    $cat2_obj3 = $("#seg1 .cat2 .obj3");
    $cat2_obj4 = $("#seg1 .cat2 .obj4");
    $cat3_obj1 = $("#seg1 .cat3 .obj1");
    $cat3_obj2 = $("#seg1 .cat3 .obj2");
    $cat3_obj3 = $("#seg1 .cat3 .obj3");
    $cat3_obj4 = $("#seg1 .cat3 .obj4");
    $cat4_obj1 = $("#seg1 .cat4 .obj1");
    $cat4_obj2 = $("#seg1 .cat4 .obj2");
    $cat4_obj3 = $("#seg1 .cat4 .obj3");
    $cat4_obj4 = $("#seg1 .cat4 .obj4");

    $cat0_text = $("#seg1 .cat0 .obj5");
    $cat1_text = $("#seg1 .cat1 .obj5");
    $cat2_text = $("#seg1 .cat2 .obj5");
    $cat3_text = $("#seg1 .cat3 .obj5");
    $cat4_text = $("#seg1 .cat4 .obj5");

    $cat0 = $("#seg1 .cat0");
    $cat1 = $("#seg1 .cat1");
    $cat2 = $("#seg1 .cat2");
    $cat3 = $("#seg1 .cat3");
    $cat4 = $("#seg1 .cat4");
  };
  Cls.fixedAreaAnime = function () {
    var delay = 700;
    if (firstFlag !== true) {
      Anime.vertical($title, "-=100px", delay, 1200, "easeOutQuint");
      Anime.vertical(
        $thermometer,
        "-=100px",
        delay - 100,
        1200,
        "easeOutQuint"
      );
      Anime.vertical($hide, "-=100px", delay - 100, 1200, "easeOutQuint");

      _DELAY = 600;
      firstFlag = true;
    }
  };
  Cls.cat0 = function () {
    if (!Cls.isAnimated) {
      Cls.isAnimated = true;
      Cls.reset($cat0);
      $cat0_obj4.text("");
      $cat0.addClass("visited");
      $cat0.css({ opacity: "1" });

      Anime.fadeHalfSizeZoomIn($cat0_obj1, 1500, "easeOutExpo", _DELAY);
      $cat0_obj4.delay(200).animate({ opacity: "1" }, 500);
      $cat0_text.delay(200).animate({ opacity: "1" }, 500);
      $cat0_obj3
        .css({ opacity: 0, top: "400px" })
        .stop()
        .delay(_DELAY + 500)
        .animate({ opacity: 1, top: "454px" }, 1000, "easeOutBack");
      $cat0_obj2
        .css({ left: "253px", opacity: "0" })
        .stop()
        .delay(_DELAY + 500)
        .animate(
          { opacity: 1, left: "480px" },
          2000,
          "easeOutQuint",
          function () {
            Cls.isAnimated = false;
          }
        );
      setTimeout(function () {
        Cls.countTemp($cat0_obj4, -35);
      }, _DELAY + 200);

      $hide
        .stop()
        .delay(_DELAY + 800)
        .animate({ height: "197px" }, 3000, "easeOutQuint");
      Cls.fixedAreaAnime();
    }
  };
  Cls.cat1 = function () {
    if (!Cls.isAnimated) {
      Cls.isAnimated = true;
      Cls.reset($cat1);
      $cat1_obj4.text("");
      $cat1.addClass("visited");
      $cat1.css({ opacity: "1" });

      Anime.fadeHalfSizeZoomIn($cat1_obj1, 1500, "easeOutExpo", _DELAY);
      $cat1_obj4.delay(200).animate({ opacity: "1" }, 500);
      $cat1_text.delay(200).animate({ opacity: "1" }, 500);
      $cat1_obj3
        .css({ opacity: 0, top: "400px" })
        .stop()
        .delay(_DELAY + 500)
        .animate({ opacity: 1, top: "454px" }, 1000, "easeOutBack");
      $cat1_obj2
        .css({ left: "253px", opacity: "0" })
        .stop()
        .delay(_DELAY + 500)
        .animate(
          { opacity: 1, left: "453px" },
          2000,
          "easeOutQuint",
          function () {
            Cls.isAnimated = false;
          }
        );
      setTimeout(function () {
        Cls.countTemp($cat1_obj4, 0);
      }, _DELAY + 200);
      $hide
        .stop()
        .delay(_DELAY + 800)
        .animate({ height: "136px" }, 3000, "easeOutQuint");
    }
  };
  Cls.cat2 = function () {
    if (!Cls.isAnimated) {
      Cls.isAnimated = true;
      Cls.reset($cat2);
      $cat2_obj4.text("");
      $cat2.addClass("visited");
      $cat2.css({ opacity: "1" });

      Anime.fadeHalfSizeZoomIn($cat2_obj1, 1500, "easeOutExpo", _DELAY);
      $cat2_obj4.delay(200).animate({ opacity: "1" }, 500);
      $cat2_text.delay(200).animate({ opacity: "1" }, 500);
      $cat2_obj3
        .css({ opacity: 0, top: "400px" })
        .stop()
        .delay(_DELAY + 500)
        .animate({ opacity: 1, top: "454px" }, 1000, "easeOutBack");
      $cat2_obj2
        .css({ left: "253px", opacity: "0" })
        .stop()
        .delay(_DELAY + 500)
        .animate(
          { opacity: 1, left: "453px" },
          2000,
          "easeOutQuint",
          function () {
            Cls.isAnimated = false;
          }
        );
      setTimeout(function () {
        Cls.countTemp($cat2_obj4, 20);
      }, _DELAY + 200);
      $hide
        .stop()
        .delay(_DELAY + 800)
        .animate({ height: "103px" }, 3000, "easeOutQuint");
    }
  };
  Cls.cat3 = function () {
    if (!Cls.isAnimated) {
      Cls.isAnimated = true;
      Cls.reset($cat3);
      $cat3_obj4.text("");
      $cat3.addClass("visited");
      $cat3.css({ opacity: "1" });

      Anime.fadeHalfSizeZoomIn($cat3_obj1, 1500, "easeOutExpo", _DELAY);
      $cat3_obj4.delay(200).animate({ opacity: "1" }, 500);
      $cat3_text.delay(200).animate({ opacity: "1" }, 500);
      $cat3_obj3
        .css({ opacity: 0, top: "400px" })
        .stop()
        .delay(_DELAY + 500)
        .animate({ opacity: 1, top: "454px" }, 1000, "easeOutBack");
      $cat3_obj2
        .css({ left: "253px", opacity: "0" })
        .stop()
        .delay(_DELAY + 500)
        .animate(
          { opacity: 1, left: "453px" },
          2000,
          "easeOutQuint",
          function () {
            Cls.isAnimated = false;
          }
        );
      setTimeout(function () {
        Cls.countTemp($cat3_obj4, 27);
      }, _DELAY + 200);
      $hide
        .stop()
        .delay(_DELAY + 800)
        .animate({ height: "96px" }, 3000, "easeOutQuint");
    }
  };
  Cls.cat4 = function () {
    if (!Cls.isAnimated) {
      Cls.isAnimated = true;
      Cls.reset($cat4);
      $cat4_obj4.text("");
      $cat4.addClass("visited");
      $cat4.css({ opacity: "1" });

      Anime.fadeHalfSizeZoomIn($cat4_obj1, 1500, "easeOutExpo", _DELAY);
      $cat4_obj4.delay(200).animate({ opacity: "1" }, 500);
      $cat4_text.delay(200).animate({ opacity: "1" }, 500);
      $cat4_obj3
        .css({ opacity: 0, top: "400px" })
        .stop()
        .delay(_DELAY + 500)
        .animate({ opacity: 1, top: "454px" }, 1000, "easeOutBack");
      $cat4_obj2
        .css({ left: "253px", opacity: "0" })
        .stop()
        .delay(_DELAY + 500)
        .animate(
          { opacity: 1, left: "453px" },
          2000,
          "easeOutQuint",
          function () {
            Cls.isAnimated = false;
          }
        );
      setTimeout(function () {
        Cls.countTemp($cat4_obj4, 80);
      }, _DELAY + 200);
      $hide
        .stop()
        .delay(_DELAY + 800)
        .animate({ height: "0px" }, 3000, "easeOutQuint");
      Cls.fixedAreaAnime();
    }
  };
  /*ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー

    ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー*/
  Cls.countTemp = function ($target, num) {
    console.log($target)
    var plusNum;
    if (num === temp) {
      $target.text(num);
      return false;
    }

    if (temp - num > 0) {
      plusNum = -1;
    } else if (temp - num < 0) {
      plusNum = 1;
    }

    $target.countUpAnimate({
      startVal: temp,
      endVal: num,
      plusVal: plusNum,
      speed: 500,
    });

    temp = num;
  };

  /*ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー

    ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー*/

  Cls.reset = function ($dom) {
    $dom.each(function () {
      $(this).css({ opacity: "0" });
    });
    $catBox.each(function () {
      if ($(this).hasClass("visited")) {
        $(this).each(function () {
          $(this)
            .find("p")
            .stop(true, true)
            .animate({ opacity: "0" }, 1000, "easeOutExpo");
        });
      }
    });
  };

  window.Seg1 = Cls;
})(window, $brand);
